import JoseraLogo from "./customer/images/josera/logo.d0767350.svg";
import DogFood from "./customer/videos/dogfood.mp4";
export const ImagePath = {
  backgroundImageMain: require("./customer/images/backgroundImage.png"),
  backgroundImageThreeMain: require("./customer/images/backgroundImageThree.png"),
  backgroundImage: require("./customer/images/josera/joseraone.png"),
  Logo: require("./logo.png"),
  JoseraLogo,
  BannerAd: require("./customer/images/BannerAd.png"),
  BannerAdJPG: require("./customer/images/BannerAd.jpg"),
  BannerAdOne: require("./customer/images/BannerAdOne.png"),
  BannerAdTwo: require("./customer/images/BannerAdTwo.png"),
  DogFood,
  Dog: require("./customer/images/dog.png"),
  Instgram: require("./customer/images/instagram.png"),
  Facebook: require("./customer/images/facebook.png"),
  Youtube: require("./customer/images/youtube.png"),
  AdPopup: require("./customer/images/AdPopup.png"),
  OffImage: require("./customer/images/offimage.png"),
  OffImageOne: require("./customer/images/offimageOne.png"),
  OffImageTwo: require("./customer/images/offimageTwo.png"),
  OffImageThree: require("./customer/images/offimageThree.png"),
  FoodImage: require("./customer/images/foodImage.png"),
  UAE: require("./customer/images/uae.png"),
  England: require("./customer/images/england.png"),
  grommingbanner1: require("./customer/images/BannerAd.jpg"),
  grommingbanner2: require("./customer/images/BannerAdTwo.png"),
  grommingbanner3: require("./customer/images/adbannerr3.png"),
  Adbanner: require("./customer/images/adBanner2.png"),
  ApplePay: require("./customer/images/applepay.png"),
  DubaiPay: require("./customer/images/dubai.png"),
  Congragulations: require("./customer/videos/congragulations.gif"),
  India: require("./customer/images/india.png"),
  PromoBanner: require("./customer/images/PromoPetBanner.png"),
  PetTaxiBanner: require("./customer/images/PetTaxiBanner.png"),
  StripBanner: require("./customer/images/stripBanner.png"),
  MainBannerPreview: require("./customer/images/mainBanner.png"),
  ScaleBanner: require("./customer/images/scalebanner.png"),
  StripBannerSmall: require("./customer/images/stripbannersmall.png"),
  StripBannerLarge: require("./customer/images/stripbannerlarge.png"),
  MultiGridBanner: require("./customer/images/maingridbanner.png"),
  StickySidebar: require("./customer/images/sidebar.png"),
  PeekCarousel: require("./customer/images/peekcarousel.png"),
  PetBanner: require("./customer/images/petbanner.png"),
  AfterDonation: require("./customer/images/afterDonation.png"),
  BeforeDonation: require("./customer/images/beforeDonation.png"),
  NoImage: require("./customer/images/NoImage.jpg"),
  Petland_Watermark: require("./customer/images/Petland_watermark.jpeg"),
  Petland_Watermark2: require("./customer/images/Petland_watermark2.png"),
  DefaultFlag:require("./customer/images/DefaultFlag.png"),
  USA:require("./customer/images/flags/USA.png"),
  UK:require("./customer/images/flags/UK.png"),
  Australia:require("./customer/images/flags/Australia.png"),
  Canada:require("./customer/images/flags/Canada.png"),
  SaudiArabia:require("./customer/images/flags/SaudiArabia.png"),
  Qatar:require("./customer/images/flags/Qatar.png"),
  Kuwait:require("./customer/images/flags/Kuwait.png"),
  Oman:require("./customer/images/flags/Oman.png"),
  Bahrain:require("./customer/images/flags/Bahrain.png"),
  Egypt:require("./customer/images/flags/Egypt.png"),
  Pakistan:require("./customer/images/flags/Pakistan.png"),
  Bangladesh:require("./customer/images/flags/Bangladesh.png"),
  SriLanka:require("./customer/images/flags/SriLanka.png"),
  Nepal:require("./customer/images/flags/Nepal.png"),
  Bhutan:require("./customer/images/flags/Bhutan.png"),
  Malaysia:require("./customer/images/flags/Malaysia.png"),
  Singapore:require("./customer/images/flags/Singapore.png"),
  Thailand:require("./customer/images/flags/Thailand.png"),
  Saleicon:require("./customer/images/Saleicon.png"),
  fb:require("./customer/images/fb.png"),
    applePay:require("./customer/images/applePay.jpg"),
    refferalBanner:require("./customer/images/refferalBanner.png"),
    petLandBackground:require("./customer/images/petLandBackground.jpeg"),
}